import React, { useEffect } from "react";
import './assets/fontawesome-pro-5.13.0/css/all.min.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './App.css';
import "./socket/socketConnection";
import routes from "./utils/routes";
import getAppData from "./appInit/appDataApi"
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Routes, Route, Navigate, } from "react-router-dom";
import {
  Login,
  Signup,
  ResetPassword,
  UpdatePassword,
  VerifyAccount,
  PageNotFound,

  Dashboard,
  Settings,
  Brands,
  Category,
  Subcategory,
  Billings,

  GalleryPictures,

  Users, UserDetails,

  Shipping,

  AddProduct,
  EditProduct,
  ProductList,
  Orders,
  RecentOrdersPage,
  Locations,
  ContactUs,
  Sliders,
  Plugins,

} from "./pages/index";
import ComingSoon from "./components/comingSoon";



function App() {
  useEffect(() => {
    let token = localStorage.getItem("token");
    if (token) {
      getAppData();
    }


  }, [])
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route index element={<Login />} />
          <Route path={routes.signup} element={<Signup />} />
          <Route path={routes.login} element={<Login />} />
          <Route path={routes.resetPassword} element={<ResetPassword />} />
          <Route path={routes.updatePassword} element={<UpdatePassword />} />
          <Route path={routes.verifyAccount} element={<VerifyAccount />} />

          <Route path={routes.dashboard} element={<Dashboard />} />

          
          <Route path={routes.settings} element={<Settings />} />
          <Route path={routes.gallery} element={<GalleryPictures />} />
          
          <Route path={routes.brands} element={<Brands />} />
          <Route path={routes.category} element={<Category />} />
          <Route path={routes.categoryDetails("")} element={<Subcategory />} />
          <Route path={routes.billings} element={<Billings />} />
          <Route path={routes.addProduct} element={<AddProduct />} />
          <Route path={routes.editProduct("")} element={<EditProduct />} />
          <Route path={routes.sliders} element={<Sliders />} />
          <Route path={routes.productList} element={<ProductList />} />
          <Route path={routes.recentOrders} element={<RecentOrdersPage />} />
          <Route path={routes.orders} element={<Orders />} />

          <Route path={routes.users} element={<Users />} />
          <Route path={routes.userDetails("")} element={<UserDetails />} />

          <Route path={routes.locations} element={<Locations />} />
          <Route path={routes.shipping} element={<Shipping />} />

          <Route path={routes.marketingTools} element={<ComingSoon title="Marketing Tools" />} />
          <Route path={routes.SEOTools} element={<ComingSoon title="SEO Tools" />} />
          <Route path={routes.plugins} element={<Plugins title="Plugins" />} />
          <Route path={routes.socialMediaLinks} element={<ComingSoon title="Social Media Links" />} />
          
          <Route path={routes.contactUs} element={<ContactUs />} />
          <Route path="*" element={<PageNotFound />} />
          {/* <Route path="*" element={<Navigate to={routes.login} />} /> */}
        </Routes>
      </BrowserRouter>
      <Toaster />
    </>
  );
}

export default App;
